// ── Constants
export const MONTHS = ["","January","February","March","April","May","June","July","August","September","October","November","December"];
export const MONTH_SHORT = ["","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export const PLAN_LIMITS = {
  Free: 5,
  Basic: 25,
  Pro: 50,
  Enterprise: 3000,
  "Enterprise Plus": 10000,
  Ultimate: 100000
};

// ── Default salary structure (overridden per company)
export const DEFAULT_CITY = "Bangalore";
export const DEFAULT_STATE = "Karnataka";
export const DEFAULT_CONFIG = {
  plan_tier: "Basic",
  custom_basic_enabled: false,
  basic_pct: 50,
  hra_customised: false,
  hra_type: "pct", hra_value: 40,
  da: false, da_pct: 0,
  lta: false, lta_pct: 8.33,
  special_allowance: false, special_allowance_type: "fixed", special_allowance_value: 0,
  conveyance: false, conveyance_amount: 1600,
  bonus: true, bonus_pct: 8.33, bonus_in_gross: true, bonus_frequency: "monthly", bonus_months: [1,2,3,4,5,6,7,8,9,10,11,12],
  gratuity: true,
  ot_applicable: false, ot_rate: 0,
  absence_deduction: false, absence_basis: "none", working_days: -1,
  min_wage_enabled: true, min_wage: 15000,
  pf_applicable: true, esi_applicable: true,
  pf_wage_cap: true,  // cap PF wage at ₹25,000
  tds_applicable: false,
  lwf_applicable: true, // Karnataka Labour Welfare Fund - ₹50 emp, Dec only
  departments: ["HR", "Finance", "DEV", "TEST"],
  designations: ["HR Admin", "Accountant", "Manager", "Director", "Lead"],
  leave_module_enabled: false,
  company_holidays: [],
  leave_types: [{ name: "Casual Leave", days: 12 }, { name: "Sick Leave", days: 6 }],
  attendance_enabled: false,
  attendance_punch_in: "09:00",
  attendance_punch_out: "18:00",
  attendance_grace_minutes: 15,
  attendance_eod_cutoff: "19:00",
  org_culture_enabled: false,
  recruitment_enabled: false,
  offboarding_enabled: false,
  addon_bulk_hike: false,
  reports_enabled: true,
  training_enabled: false,
  doc_hub_enabled: false,
};
